/**
 * Shared utility functions for AI exchange feature validation
 */

import { Step } from "../return-flow";

/**
 * Configuration interface for AI exchange settings
 */
export interface AiExchangeSettings {
  enabled: boolean;
  trialEndDate?: Date | null;
}

/**
 * Checks if AI exchange suggestions are enabled based on both flow configuration and team settings
 * @param flowStep - The return flow step configuration
 * @param aiExchangeSettings - The AI exchange settings from team configuration
 * @returns boolean indicating if AI exchange suggestions should be enabled
 */
export function isAiExchangeEnabled(
  flowStep: Step.Return | undefined,
  aiExchangeSettings: AiExchangeSettings | undefined,
): boolean {
  // First check if AI exchange is enabled in the flow step
  if (!flowStep?.enableAiExchangeSuggestion) {
    return false;
  }

  // Check if we have the AI exchange settings
  if (!aiExchangeSettings) {
    return false;
  }

  // Check if the feature is enabled
  if (aiExchangeSettings.enabled) {
    return true;
  }

  // Check if we're within the trial period
  const now = new Date();
  if (
    aiExchangeSettings.trialEndDate &&
    new Date(aiExchangeSettings.trialEndDate) >= now
  ) {
    return true;
  }

  return false;
}
